{
	"common": {
		"loadFailed": "Could not load this",
		"tryAgain": "Try again"
	},
	"time": {
		"unknown": "Time not known yet",
		"until": "to {{time}}",
		"dayAt": "{{day}}, {{time}}"
	},
	"ready": {
		"card": "Approved {{n}}/{{of}}",
		"cardHint": "{{n}} of {{of}} cards approved",
		"beds": "Beds {{n}}/{{of}}",
		"bedsHint": "{{n}} of {{of}} people have a bed",
		"checkedOut": "Checked out {{n}}/{{of}}",
		"checkedOutHint": "{{n}} of {{of}} people have checked out",
		"transfer": {
			"missing": "No transfer {{n}}",
			"waiting": "No driver {{n}}",
			"en_route": "En route",
			"assigned": "Driver assigned",
			"done": "Transfer done",
			"recheck": "Driver to re-check {{n}}"
		},
		"transferHint": {
			"missing": "{{n}} of {{of}} people who need transport have no transfer yet",
			"waiting": "{{n}} of {{of}} people are on a transfer that has no driver yet",
			"en_route": "Transfers are on the road",
			"assigned": "Everyone who needs transport has a driver",
			"done": "Every transfer has arrived",
			"recheck": "{{n}} of {{of}} people have a driver who must be re-checked: a delay moved the trip"
		},
		"landed": "Landed",
		"left": "Left",
		"recheckNoc": "Driver being confirmed {{n}}",
		"recheckNocHint": "{{n}} of {{of}} people: the host is confirming their driver after a schedule change"
	},
	"list": {
		"arrivals": "Arrivals",
		"departures": "Departures",
		"direction": "Direction",
		"count_one": "{{n}} journey · {{people}}",
		"count_other": "{{n}} journeys · {{people}}",
		"people_one": "{{n}} person",
		"people_other": "{{n}} people",
		"contingents_one": "{{n}} contingent",
		"contingents_other": "{{n}} contingents",
		"search": "Flight, service, origin, name or card number",
		"filters": "Filters",
		"filtersCount": "Filters ({{n}})",
		"sort": {
			"next": "Next up",
			"time_asc": "Earliest first",
			"time_desc": "Latest first",
			"people_desc": "Most people"
		},
		"chips": {
			"status": "Status",
			"shared": "Shared journeys",
			"late": "Delayed",
			"notReady": "Not ready",
			"notReadyAtom": {
				"card": "Card not approved",
				"transfer": "No driver yet",
				"bed": "No bed",
				"recheck": "Driver to re-check"
			},
			"atRisk": "Connection at risk",
			"manual": "Set by hand",
			"range": "{{from}} to {{to}}",
			"organisation": "Contingent"
		},
		"table": {
			"arrives": "Arrives ({{zone}})",
			"departs": "Departs ({{zone}})",
			"contingent": "Contingent",
			"travel": "Travel",
			"people": "People",
			"ready": "Ready",
			"status": "Status"
		},
		"heading": "{{name}} · {{when}} · {{entry}}",
		"headingMeta": "{{contingents}} · {{people}}",
		"cardMeta": "{{name}} · {{entry}} · {{people}}",
		"route": "{{from}} → {{to}}",
		"routeCarrier": "{{from}} → {{to}} · {{carrier}}",
		"approvedOf": "{{n}} of {{of}} approved",
		"needTransport_one": "{{n}} needs transport",
		"needTransport_other": "{{n}} need transport",
		"delayedSome_one": "{{delayed}} of {{n}} delayed",
		"delayedSome_other": "{{delayed}} of {{n}} delayed",
		"atRisk_one": "{{n}} connection at risk",
		"atRisk_other": "{{n}} connections at risk",
		"setByHand": "Set by hand",
		"shown_one": "Showing {{shown}} of {{n}} journey",
		"shown_other": "Showing {{shown}} of {{n}} journeys",
		"more": "Show more journeys",
		"empty": {
			"filteredTitle": "No journeys match",
			"filteredHint": "Try another status or day, or clear the filters.",
			"clear": "Clear filters",
			"noArrivals": "No arrivals on these days",
			"noDepartures": "No departures on these days",
			"noneHint": "Journeys appear here once travel is added to approved records.",
			"noneHintAdd": "Add travel to records, or pick another day."
		}
	},
	"guide": {
		"title": "Journey statuses",
		"status": "Flight status",
		"ready": "Ready",
		"readyNoteArrival": "Before arrival, everyone needs an approved card, a driver if they need transport, and a bed.",
		"readyNoteDeparture": "Before departure, everyone needs an approved card and a driver if they need transport, and checks out of their room.",
		"card": "Cards approved",
		"cardHint": "Approved cards out of everyone on the journey. Transport and rooms wait for approval.",
		"transferMissing": "No transfer",
		"transferMissingHint": "People who need transport but are on no transfer yet.",
		"transferWaiting": "No driver",
		"transferWaitingHint": "A transfer exists, but no driver or vehicle is assigned yet.",
		"transferAssigned": "Driver assigned",
		"transferAssignedHint": "Everyone who needs transport has a driver. It then shows En route and Transfer done.",
		"beds": "Beds",
		"bedsHint": "People with a bed to go to, out of everyone on the journey.",
		"checkedOut": "Checked out",
		"checkedOutHint": "People who have checked out of their room.",
		"flags": "Filters",
		"lateHint": "Journeys with at least one person running late.",
		"notReadyHint": "Arrivals still to come where someone is missing an approved card, a driver or a bed.",
		"sharedHint": "Flights or services carrying more than one contingent.",
		"transferRecheck": "Driver to re-check",
		"transferRecheckHint": "A driver is assigned, but a delay moved the trip off the driver's shift or released a vehicle. Not ready until dispatch confirms the driver again.",
		"transferRecheckNoc": "Driver being confirmed",
		"transferRecheckNocHint": "After a schedule change, the host is confirming the driver again. Not ready until it is confirmed."
	},
	"filters": {
		"from": "From",
		"to_one": "To (at most {{count}} day)",
		"to_other": "To (at most {{count}} days)",
		"mode": "Travel mode",
		"entryPoint": "Entry point",
		"entryPointOption": "{{code}} · {{name}}",
		"organisation": "Contingent",
		"any": "Any",
		"clear": "Clear",
		"apply": "Apply filters"
	},
	"detail": {
		"title": "Journey",
		"subtitle": "{{direction}} · {{entry}}",
		"arrival": "Arrival",
		"departure": "Departure",
		"back": "Back to journeys",
		"backToList": "Back to journeys",
		"notFound": "Journey not found",
		"notFoundHint": "It may have moved to another time, or none of its people are yours to see.",
		"tag": "{{direction}} · {{mode}}",
		"flight": "Flight",
		"service": "Service",
		"whereShared": "{{entry}} · {{contingents}}",
		"contingents_one": "{{n}} contingent",
		"contingents_other": "{{n}} contingents",
		"latest": "Latest update",
		"latestNoReason": "Flight updated",
		"latestBy": "{{time}} · {{name}}",
		"latestNone": "No changes recorded yet",
		"latestService": "Times as booked. A delay set here moves everyone on it.",
		"setByHand": "Set by hand",
		"origin": "Origin",
		"from": "From",
		"destination": "Destination",
		"to": "To",
		"routeMid": "{{name}} · {{duration}}",
		"delayedSome_one": "{{delayed}} of {{n}} delayed",
		"delayedSome_other": "{{delayed}} of {{n}} delayed",
		"print": "Print"
	},
	"steps": {
		"label": "Progress",
		"cards": "Cards approved",
		"transfer": "Transfer arranged",
		"ownTransport": "Own transport",
		"departedOrigin": "Departed",
		"landed": "Landed",
		"checkedIn": "Checked in",
		"checkedOut": "Checked out",
		"departed": "Departed",
		"count": "{{n}} of {{of}}",
		"done": "done",
		"now": "next",
		"todo": "not yet"
	},
	"attention": {
		"CANCELLED": "This flight is cancelled.",
		"DIVERTED": "This flight was diverted.",
		"notApproved_one": "{{n}} card not approved yet",
		"notApproved_other": "{{n}} cards not approved yet",
		"noBed_one": "{{n}} person without a bed",
		"noBed_other": "{{n}} people without a bed",
		"noTransfer_one": "{{n}} person needs transport and has no driver yet",
		"noTransfer_other": "{{n}} people need transport and have no driver yet",
		"noDriver": "{{ref}} has no driver yet",
		"moreTrips_one": "{{n}} more trip",
		"moreTrips_other": "{{n}} more trips",
		"atRisk_one": "{{n}} connection at risk",
		"atRisk_other": "{{n}} connections at risk",
		"driverRecheck_one": "{{n}} person's driver must be re-checked",
		"driverRecheck_other": "{{n}} people's drivers must be re-checked",
		"driverRecheckNoc_one": "{{n}} person's driver is being confirmed",
		"driverRecheckNoc_other": "{{n}} people's drivers are being confirmed",
		"tripRecheck": "{{ref}}: re-check the driver",
		"arrange": "Arrange in Transportation →",
		"assignRooms": "Assign rooms →"
	},
	"facts": {
		"title": "Travel details",
		"carrier": "Carrier",
		"service": "Service",
		"mode": "Transportation",
		"boardingFrom": "Boarding from",
		"goingTo": "Going to",
		"passengers": "Passengers",
		"passengersShared": "{{people}} in {{contingents}}",
		"pickup": "Pickup from",
		"pickupValue_one": "{{time}} ({{n}} min after arrival)",
		"pickupValue_other": "{{time}} ({{n}} min after arrival)",
		"pickupUnknown": "Once the time is known",
		"departureBooked": "Departure booked",
		"arrivalBooked": "Arrival booked",
		"ofPeople": "{{n}} of {{of}}"
	},
	"parts": {
		"title": "Contingents on board",
		"people_one": "{{n}} person",
		"people_other": "{{n}} people"
	},
	"passengers": {
		"title": "Passengers",
		"show": "Show",
		"all": "All",
		"notApproved": "Card not approved",
		"noBed": "No bed",
		"noTransfer": "No driver yet",
		"nobody": "Nobody in this list",
		"more": "Show more passengers",
		"open": "Open {{name}}'s record",
		"wheelchair": "Wheelchair",
		"noBedRow": "No bed",
		"noTransferRow": "No transfer",
		"ownTransport": "Own transport",
		"gender": {
			"MALE": "M",
			"FEMALE": "W"
		},
		"driverRecheck": "Driver to re-check",
		"driverRecheckNoc": "Driver being confirmed",
		"driverRecheckHint": "A delay moved this trip: dispatch must confirm the driver again",
		"driverRecheckNocHint": "The host is confirming the driver after a schedule change"
	},
	"history": {
		"title": "History",
		"none": "Nothing recorded yet",
		"more": "Show older",
		"created": "Flight added",
		"changed": "Flight updated",
		"change": "{{field}}: {{from}} → {{to}}",
		"empty": "none",
		"field": {
			"status": "Status",
			"tracking": "Tracking",
			"scheduled_departure_at": "Scheduled departure",
			"scheduled_arrival_at": "Scheduled arrival",
			"estimated_departure_at": "Estimated departure",
			"estimated_arrival_at": "Estimated arrival",
			"actual_departure_at": "Departed",
			"actual_arrival_at": "Landed"
		},
		"tracking": {
			"PROVIDER": "Tracked",
			"MANUAL": "Set by hand"
		},
		"system": "Flight tracker",
		"migration": "System update",
		"someone": "Someone",
		"byAgent": "{{name}} (AI assistant)"
	},
	"dayHints": {
		"badgeArrivals_one": "{{n}} arrival journey · {{people}}",
		"badgeArrivals_other": "{{n}} arrival journeys · {{people}}",
		"badgeDepartures_one": "{{n}} departure journey · {{people}}",
		"badgeDepartures_other": "{{n}} departure journeys · {{people}}",
		"notReady_one": "{{n}} arrival journey today or tomorrow is not ready",
		"notReady_other": "{{n}} arrival journeys today or tomorrow are not ready",
		"showThem": "Show them",
		"journeys_one": "{{n}} journey",
		"journeys_other": "{{n}} journeys",
		"nextArrivals": "Next arrivals: {{day}} · {{journeys}}",
		"nextDepartures": "Next departures: {{day}} · {{journeys}}",
		"earlierArrivals": "Earlier arrivals: {{day}} · {{journeys}}",
		"earlierDepartures": "Earlier departures: {{day}} · {{journeys}}",
		"goTo": "Go to {{day}}",
		"noneWeekArrivals": "No arrivals this week — use ‹ › or Pick a day.",
		"noneWeekDepartures": "No departures this week — use ‹ › or Pick a day."
	}
}
